
import { Component, Vue, Prop } from 'vue-property-decorator'
import StatusDot from '@/components/status_dot/index.vue'

@Component({
    name: 'company-settle-table',
    components: {
        StatusDot
    }
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]
    private statusOption = {
        Ing: 0,
        Pass: 1,
        Fail: 2
    }

    private onGoDetail(company: any) {
        const href = `/enterprise/settle/${company.id}` 
        window.open(href, '_blank')
    }
    private formatIndustryName(industryName: any): string {
        if (!industryName) return '无'
        let industryList: any[] = []
        if (typeof industryName === 'string') {
            try {
                industryList = JSON.parse(industryName)
            } catch (e) {
                return industryName
            }
        } else if (Array.isArray(industryName)) {
            industryList = industryName
        }
        return industryList.length > 0 ? industryList.join('、') : '无'
    }
    private formatProducts(products: any): string {
        if (!products) return '无'
        let productList: any[] = []
        if (typeof products === 'string') {
            try {
                productList = JSON.parse(products)
            } catch (e) {
                return products
            }
        } else if (Array.isArray(products)) {
            productList = products
        }
        if (productList.length === 0) return ''
        return productList.map((p: any) => p.name || p).join('、')
    }
}
